/**
 * Shared policy for the current-user query. Keeping this data briefly cached
 * prevents mounting a feature tab from immediately issuing a new auth request.
 * Explicit logout still clears and invalidates this query.
 */
export const AUTH_QUERY_POLICY = {
  retry: false,
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
  refetchOnMount: false,
  staleTime: 5 * 60 * 1000,
  gcTime: 10 * 60 * 1000,
} as const;

export const IDLE_TIMEOUT_QUERY_POLICY = {
  retry: false,
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
  staleTime: 60 * 1000,
  gcTime: 5 * 60 * 1000,
  refetchInterval: 60 * 1000,
} as const;
